export enum InvoiceStatuses {
  checked = 'CHECKED',
  confirmed = 'CONFIRMED',
  credited = 'CREDITED',
  emailed = 'EMAILED',
  pending = 'PENDING',
  posted = 'POSTED',
  printed = 'PRINTED',
}
